export default __webpack_public_path__ + "img/8975bfa9cace905817ed10a7e32ff77b.png";